import { type WorkspaceAgentMessage } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentMessage';

/** Latest user message in the thread, including optimistic rows. */
export const getLatestWorkspaceAgentUserMessage = (messages: WorkspaceAgentMessage[]): WorkspaceAgentMessage | null => {
  let latestUserMessage: WorkspaceAgentMessage | null = null;

  for (const message of messages) {
    if (message.role !== 'user') {
      continue;
    }

    if (latestUserMessage === null || message.sequence >= latestUserMessage.sequence) {
      latestUserMessage = message;
    }
  }

  return latestUserMessage;
};
